<template id="mainbody">
<main @click="globalClick">
<sectionBanner :name="name" :bannerclass="bannerclass" :sname="res.sname?res.sname:sname"></sectionBanner>
<contentArea :name="name" :sname="res.sname?res.sname:sname" :content="res.content?res.content:content" :rowalign="rowalign"></contentArea>
<aboutInfo v-if="isListed('aboutInfo')" :name="name" :info="info"></aboutInfo>
<productsIncludes v-if="isListed('productsIncludes')" :name="name" :info="info"></productsIncludes>
<clientsIncludes v-if="isListed('clientsIncludes')" :res="res" :clients="info.clients" :name="name"></clientsIncludes>

<section v-if="isListed('thanks')" class="thanks hidden-xs">
  <div class="container">
    <div class="row"> 
      <!---------->
      <div class="col-sm-12">
        <div class="thankyou"> <img src="@/images/orderdetails.png" alt="image">
          <h1 v-html="common_res.thankyou"></h1>
          <p v-html="common_res.thankyou_msg"> Your order will be processed by our account manager. We will ship your order in <br>
          <span class="business"><span class="three">3 </span> business days </span> after confirmation of payment.</p>
        </div>
      </div>
      <!---------> 
    </div>
  </div>
</section>

<section v-if="isListed('orderInfo')">
  <div class="container">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="headingBar">
          <h3>{{res.purchase}}</h3>
          <span><img alt="#" src="@/images/icon-headingbar.png"></span> </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-sm-6  col-xs-12">
        <div class="firstOrderInfo">
          <div class="firstCartIcon textRight"> <img src="@/images/cart.png" alt="#" class=""></div>
          <h4><span>{{firstamt.currency}}</span>{{firstamt.value}}<img src="@/images/plush.png" alt="#" class="plusIcon"></h4>
        </div>
      </div>
      <div class="col-md-6 col-sm-6  col-xs-12">
        <div class="firstOrderinfoRightColumn" v-if="res.orderinfo != null">
          <h2>{{res.minpurchase}}</h2>
          <p v-html="res.orderinfo.replace('${firstamt}', firstamt.currency+' '+firstamt.value)"></p>
        </div>
      </div>
    </div>
  </div>
</section>
<section v-if="isListed('deliveryInfo')" class="deliveryInfoBlock">
  <div class="container">
    <div class="row" v-if="res.deliveryinfo != null">
      <div class="col-md-6 col-sm-6">
        <div class="infoBlocks">
          <div class="infoBlocksIcons"><img src="@/images/payment.png" alt="#"></div>
          <h2>{{res.payment}}</h2>
          <p v-html="res.deliveryinfo.payment"></p>
        </div>
      </div>
      <div class="col-md-6 col-sm-6">
        <div class="infoBlocks">
          <div class="infoBlocksIcons"><img src="@/images/payment_terms.png" alt="#"></div>
          <h2>{{res.deliveryterm}}</h2>
          <p v-html="res.deliveryinfo.delivery.replace('${firstamt}', firstamt.currency+' '+firstamt.value)"></p>
        </div>
      </div>
      <div class="col-md-12 col-sm-12">
        <p v-html="res.deliveryinfo.doreg"></p>
      </div>
    </div>
  </div>
</section>
<regForm @iposevent="doEvent" v-if="isListed('regForm')" :common_res="info.common_res" :res="info.res" :name="name" :clients="info.clients" :firstamts="info.firstamts" :currencies="currencies" :countries="info.countries"></regForm>
<breadCrumb @iposevent="doEvent" v-if="isListed('breadCrumb')" :res="info.res" :name="name" :clients="info.clients" :firstamts="info.firstamts" :countries="info.countries"></breadCrumb>
<productList :shelf_mode="info.shelf_mode" :pdiscounts="info.pdiscounts" :order_processing="info.processing" :mode="mode" @iposevent="doEvent" v-if="authed && ((isListed('productList') && app == null) || app == 'productList')" :common_res="info.common_res" :res="info.res" :name="name" :clients="info.clients" :firstamts="info.firstamts" :countries="info.countries"></productList>
<productShelf :shelf_mode="info.shelf_mode" :pdiscounts="info.pdiscounts" :order_processing="info.processing" :mode="mode" @iposevent="doEvent" v-if="authed && ((isListed('productShelf') && app == null) || app == 'productList')" :common_res="info.common_res" :res="info.res" :name="name" :clients="info.clients" :firstamts="info.firstamts" :countries="info.countries"></productShelf>
<cart :deliverylist="info.delivery" :currencies="currencies" :mode="mode" @iposevent="doEvent" v-else-if="authed && ((isListed('cart') && app == null) || app=='cart')" :companyinfo="info.companyinfo" :common_res="info.common_res" :res="info.res" :name="name" :discountlist="info.discountlist" :cart="info.cart" :countries="info.countries"></cart>
<account @iposevent="doEvent" v-else-if="authed && isListed('acc')" :locales="locales" :common_res="info.common_res" :res="info.res" :name="name" :account="info.account" :countries="info.countries"></account>
<orderlist @iposevent="doEvent" v-else-if="authed && isListed('orderlist')" :files="info.files" :ranking="info.ranking" :companyinfo="info.companyinfo" :res="info.res" :name="name" :orders="info.orders" :common_res="info.common_res" :report="info.report" :discountlist="info.discountlist" :countries="info.countries"></orderlist>
<orderdetails :paymentinfo="info.paymentinfo" :slist="slist" :invoice="info.invoice" :mode="mode" @iposevent="doEvent" v-else-if="authed && ((isListed('orderdetails') && app == null))" :companyinfo="info.companyinfo" :common_res="info.common_res" :res="info.res" :name="name" :discountlist="info.discountlist" :cart="info.cart" :countries="info.countries"></orderdetails>

<resetPwd @iposevent="doEvent" v-if="isListed('resetPwd')" :common_res="info.common_res" :res="info.res" :name="name" :token="info.token"></resetPwd>
<pwdSent @iposevent="doEvent" v-if="isListed('pwdSent')" :res="info.res" :name="name" :clients="info.clients" :firstamts="info.firstamts" :countries="info.countries"></pwdSent>
<regLogin @iposevent="doEvent" v-if="(authed==false && !isListed('pwdSent') && !isListed('thankyou') && !isListed('resetPwd') && !isListed('pwdSent') && !isListed('regForm')) || isListed('regLogin')" :common_res="info.common_res" :res="info.common_res.reglogin" :name="name" :clients="info.clients" :firstamts="info.firstamts" :countries="info.countries"></regLogin>

<!--hotlineBar :name="name"></hotlineBar-->
<section>
  <div class="full_mobile_menu">
    <div class="container">
      <div class="col-xs-12">
        <div class="list">
          <ul>
            <li><a href="#">About US</a></li>
            <li><a href="#">Reseller Registration</a></li>
            <li><a href="#">Reseller Login</a></li>
            <li><a href="#">SampsonStore.com</a></li>
          </ul>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="White_logo"> <img alt="#" src="@/images/white_logo.png">
          <p>Unit D, 3/F, V Ga Building, 532 Castle Peak Rd, Cheung Sha Wan</p>
        </div>
      </div>
    </div>
  </div>
</section>
<statusModal :common_res="common_res" :id="'msgoverlay'"></statusModal>
<blankModal :common_res="common_res" :id="'blank'"></blankModal>
<mainfooter v-if="common_res.footer_text != null" :footer_text="common_res.footer_text"></mainfooter>
</main>
</template>

<script>

import mainfooter from './MainFooter.vue'
import hotlineBar from './HotlineBar.vue'
import sectionBanner from './SectionBanner.vue'
import contentArea from './ContentArea.vue'
import clientsIncludes from './ClientsIncludes.vue'
import productsIncludes from './ProductsIncludes.vue'
import regForm from './RegForm.vue'
import pwdSent from './PwdSent.vue'
import breadCrumb from './BreadCrumb.vue'
import productList from './ProductList.vue'
import orderlist from './OrderList.vue'
import orderdetails from './OrderDetails.vue'
import cart from './Cart.vue'
import account from './Account.vue'
import regLogin from './RegLogin.vue'
import resetPwd from './ResetPwd.vue'
import aboutInfo from './AboutInfo.vue'
import statusModal from './StatusModal.vue'
import blankModal from './ModalBox.vue'
import productShelf from './ProductShelf.vue'
import utils from './Utils.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

export default {
  name: 'mainbody',
  props:['mode', 'url', 'name', 'title', 'sname', 'content', 'slist', 'info', 'rowalign', 'bannerclass', 'logon', 'chkscroll'],
  data () {
    return {
      "common_res":{},
      "currencies":[],
      "res":{},
      "curr":null,
      "firstamt":{},
      "authed":null,
      "app":null,
      //"pmode":'list',
      "tologin":false,
    }
  },
  computed: {
    locales: function() {
      var locs = [];
      if (this.info.common_res.header_text == null) return locs;
      var n = this.info.common_res.header_text[utils.getHostname()];
      if (n == null) {
        n = this.info.common_res.header_text;
      }
      //Object.keys(this.info.common_res.header_text[utils.getHostname()]).forEach(itemKey => {
      Object.keys(n).forEach(itemKey => {
        if (itemKey.indexOf('locale_') == 0) {
          var k = itemKey.substring(7);
          var v = n[itemKey];
          locs.push({"id":k, "name":v});
        }
      });
      return locs;
    }
  },
  components: {
    hotlineBar,
    contentArea,
    aboutInfo,
    statusModal,
    blankModal,
    clientsIncludes,
    productsIncludes,
    mainfooter,
    regForm,
    pwdSent,
    breadCrumb,
    productList,
    productShelf,
    orderlist,
    orderdetails,
    cart,
    account,
    regLogin,
    resetPwd,
    //regForm:() => {console.log('rf:'+this.slist);return import ('./RegForm.vue')},
    sectionBanner
  },
  created: function() {
    //this.pmode = Vue.cookie.get('pmode');
    //if (this.pmode == null) {
    //  this.pmode = 'list';
    //}
    console.log('main', this.info);
    this.curr = utils.getCurrencySym();
    this.currencies.push({"desp":this.info.config.currency, "value":""});
    if (this.info.config.currencies != '') {
      var c = JSON.parse(this.info.config.currencies);
      for (var i=0;i<c.length;i++) {
        this.currencies.push({"desp":c[i], "value":c[i]});
      }
    }
  },
  methods: {
    getFirstAmt() {
      if (this.info.firstamts != null && this.info.firstamts.length > 0) {
        var f = numeral(this.info.firstamts[0].value).format('0,0');
        var sign = this.info.firstamts[0].desp.split(' ')[0];
        return {'value':f, 'currency':sign};
      }
      return {'value':0, 'currency':this.curr};
    },
    doEvent:function(name, obj) {
      this.$emit(name, obj);
    },
    globalClick:function() {
      utils.EventBus.$emit('global-click');
    },
    isListed: function(lname) {
      if (this.slist == null) return false;
      for (var i=0;i<this.slist.length;i++) {
        if (this.slist[i] == lname) return true;
      }
      return false;
    },
    bottomVisible() {
      const scrollY = window.scrollY
      const visible = document.documentElement.clientHeight
      var pageHeight = document.documentElement.scrollHeight
      var fheight = 0;
      if ($('#base_footer').length > 0) {
        fheight = $('#base_footer').outerHeight();
        //pageHeight = pageHeight - fheight;
      }
      const bottomOfPage = visible + scrollY >= (pageHeight - fheight)
      return bottomOfPage || pageHeight < visible
    },
    chkScroll () {
      var self = this;
      window.onscroll = () => {
        //if (document.body.scrollHeight - window.innerHeight - document.body.scrollTop - fheight <= 0) {
        if (self.bottomVisible()) {
          self.$root.$emit('scroll', 'bottom');
        }
      };
    }
  },
  mounted: function() {
    if (this.chkscroll) {
      this.chkScroll();
    }
    this.common_res = this.info.common_res;
    this.res = this.info.res;
    if (this.res == null) this.res = {};
    if (this.res.title) {
      $('#title').html(this.res.title);
    } else {
      $('#title').html(this.title);
    }
    this.firstamt = this.getFirstAmt();

    if (this.logon) {
      if (this.info.authed) {
        this.authed = true;
        this.$root.$emit('authed');
      } else {
        this.tologin = true;
      }
    }

    this.$root.$on('authed', data => {
      this.authed = true;
      if (window.location.href.indexOf('/reglogin') >= 0) {
        window.location.href=utils.getPageRoot()+'/product/index.html';
      } else {
        window.location.reload();
      }
    });
    this.$root.$on('search', data => {
      console.log('main search', data);
    });
    this.$root.$on('tologin', data => {
      window.location.href=utils.getPageRoot()+'/reglogin.html';
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MainBody.vue